import React, { useEffect, useCallback } from "react";
import Join from "./Join";
import { joinAction, JOIN_INIT } from "../actionCreators";
import { getFormValues } from "redux-form";
import { useDispatch, connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { JOIN_SUCCESS_MSG } from "../../common/constants/commonConstant";

const JoinContainer = ({ values }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isJoined, joinErrorReason } = useSelector(state => state.joinReducer);

  const onSubmit = e => {
    const { empNum, id, name, password } = values;
    dispatch(joinAction({ empNum, id, name, password }));
  };

  const onClickCancel = useCallback(
    e => {
      navigate("/");
    },
    [navigate]
  );

  useEffect(() => {
    if (isJoined) {
      alert(JOIN_SUCCESS_MSG);
      dispatch({
        type: JOIN_INIT
      });
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isJoined, joinErrorReason]);

  return (
    <Join
      onSubmit={onSubmit}
      error={joinErrorReason}
      onClickCancel={onClickCancel}
    ></Join>
  );
};

export default connect(state => ({
  values: getFormValues("JoginForm")(state)
}))(JoinContainer);
